import SeoHead from "@/components/SeoHead";
import Header from "@/components/Header";
import PageBreadcrumb from "@/components/PageBreadcrumb";
import AIForLeaders from "@/components/AIForLeaders";
import AILyftet from "@/components/AILyftet";
import AIMasterclass from "@/components/AIMasterclass";
import CallToAction from "@/components/CallToAction";
import Footer from "@/components/Footer";

const AISkilling = () => {
  return (
    <>
      <SeoHead
        title={{
          en: "AI-skilling Programs | AI-labbet",
          sv: "AI-kompetens & utbildning | AI-labbet",
        }}
        description={{
          en: "AI training programs for leaders and teams. Build AI capabilities with our comprehensive skilling courses and masterclasses.",
          sv: "AI-utbildningar för ledare och team. Bygg AI-förmåga med våra omfattande kompetensprogram och masterclasses.",
        }}
        path="/ai-skilling"
      />
      
      <div className="min-h-screen bg-background">
        <Header />
        <PageBreadcrumb currentPage="aiSkilling" />
        
        <main>
          <h1 className="sr-only">AI-skilling Programs</h1>
          <AIForLeaders />
          <AILyftet />
          <AIMasterclass />
          
          <CallToAction />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default AISkilling;
